'use client';

import { MessagePrimitive } from '@assistant-ui/react';
import { type JSX } from 'react';

import { Icon } from '@videoblocks/design-system';

/**
 * Shown in the chat thread when the conversation exceeds the model's context window
 * (the stream returns the CONTEXT_LENGTH_EXCEEDED sentinel). Retrying the same oversized
 * history would just fail again, so the only action is to start a fresh chat.
 */
export function ConversationTooLongNotice(): JSX.Element {
    return (
        <MessagePrimitive.Root className="py-3" data-role="assistant">
            <div className="flex flex-row items-start gap-4 rounded-[14px] border border-[#D4D6D9] bg-[#EFEFEF] p-4">
                <Icon name="error" width={20} height={20} className="shrink-0 [&_path]:fill-[#737E8C]" />
                <p className="flex-1 text-sm leading-5 text-[#36414D]">
                    We do not support conversations with this many queries – please{' '}
                    {/* Plain anchor (not next/link) forces a full navigation so the in-memory chat
                        thread resets — a soft route change to /new keeps the current messages. */}
                    <a href="/ai/conv-search/new" className="underline hover:no-underline">
                        start a new chat
                    </a>
                </p>
            </div>
        </MessagePrimitive.Root>
    );
}
